<template>
	<div>
		<div class="flex-betweenCenter padding-top20 padding-bottom20  " v-for="(item,index) in list" :key="index"
			@click="detail?'':$toPage('school/'+item.id)">
			<div class="flex-startCenter width80p">
				<img :src="item.badge_url?item.badge_url:'@/assets/images/logo.png'" :alt="item.name"
					:class="detail?'width80 height80':'width60 height60'">
				<div class="margin-left20">
					<div class="flex-startCenter">
						<div class="weight550" :class="detail?'font26':'font18 card-title'" v-html="highlightText(item.name)">
						</div>
						<div v-if="item.province"
							class="flex-center border border-radius60 color-grey6 padding-left12 padding-right12 margin-left12"
							:class="detail?'line-height32 font14':'line-height22 font12'">
							<i class="el-icon-location-outline margin-right2"></i>
							{{item.province?.name}}{{item.city?.name}}
						</div>
					</div>
					<div class="color-grey6 margin-top4">
						{{ [item.institution_type_name, item.institution_nature_name, item.main_department] | joinNonEmpty }}
					</div>
					<!-- <div class="color-grey6 margin-top4">
						
						{{item.institution_type_name?item.institution_type_name:''}} |
						{{item.institution_nature_name?item.institution_nature_name:''}} | 教育部直属
					</div> -->
					<div class="margin-top8 flex-wrap">
						<div v-for="(tag,tagindex) in item.characteristics" :key="tagindex"
							class="padding0-8 border-radius4 line-height22 margin-right10 margin-bottom10"
							:class="detail?'color-blue border-blue':'bg-grey color-grey6 border'">
							{{tag.name}}
						</div>
					</div>
				</div>
			</div>
			<div v-if="hasBtn" class="" :class="detail?'flex-endCenter':'flex-columnCenter'">
				<div class="line-height28 padding0-15" :class="[
					    detail ? 'flex-columnCenter' : 'flex-center border-radius46 border margin-bottom10',
					    (!detail &&(item.favorite_status||item.favorite?.object_id==item.id)) ? 'bg-blue-opa' : ''
					  ]" @click.stop="handelFavorite(item.id,index,item.favorite_status)">
					<img v-if="item.favorite_status||item.favorite?.object_id==item.id" src="@/assets/images/college1.png" alt=""
						class="width18 height18" :class="detail?'width32 height32':'width18 :height18'" />

					<img v-else src="@/assets/images/college.png" alt="" lass="width18 height18"
						:class="detail?'width32 height32':'width18 :height18'" />

					<div :class="item.favorite_status||item.favorite?.object_id==item.id?'color-blue':''">

						{{detail?(item.favorite_status||item.favorite?.object_id==item.id?'已关注':'关注'):'收藏'}}
					</div>
				</div>
				<!-- <el-divider v-if="detail" direction="vertical"></el-divider> -->
				<div v-if="!detail" class="line-height28 padding0-15" :class="[
						    detail ? 'flex-columnCenter' : 'flex-center border-radius46 border margin-bottom10',
						    (!detail && item.compared) ? 'bg-blue-opa' : ''
						  ]" @click.stop="handelAddCompare(item)">
					<img v-if="item.compared " src="@/assets/images/comparison1.png" alt="" class="width18 height18"
						:class="detail?'width32 height32':'width18 :height18'" />

					<img v-else src="@/assets/images/comparison.png" alt="" lass="width18 height18"
						:class="detail?'width32 height32':'width18 :height18'" />

					<div :class="item.compared?'color-blue':''">对比</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		favorite
	} from '@/api/user'
	import {
		compare
	} from '@/api/school'

	export default {
		name: 'ItemUni',
		props: {
			detail: {
				type: Boolean,
				default: false
			},
			list: {
				type: Array,
				default () {
					return []
				}
			},
			hasBtn: {
				type: Boolean,
				default: true
			},
			keyword: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				hasLogin: !!localStorage.getItem('token'),
			}
		},
		methods: {
			highlightText(text) {
				if (!this.keyword || !text) return text;

				// 按空格分割关键词
				const keywords = this.keyword.trim().split(/\s+/).filter(k => k.length > 0);

				if (keywords.length === 0) return text;

				// 转义并组合正则表达式
				const escapedKeywords = keywords.map(k => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
				const regex = new RegExp(`(${escapedKeywords.join('|')})`, 'gi');

				// 替换匹配的文本
				return text.replace(regex, '<span class="highlight-text">$1</span>');
			},
			handelAddCompare(item) {
				if (!this.hasLogin) {
					this.$bus.$emit('showLoginModal')
					return
				}
				// 如果已经是选中状态，不允许重复添加
				if (item.compared) {
					this.$message.warning('该院校已在对比列表中')
					return
				}

				// 获取当前已选中的数量（使用父组件传递的列表）
				const selectedCount = this.list.filter(i => i.compared).length

				// 限制最多5个
				if (selectedCount >= 5) {
					this.$message.warning('最多只能对比5所院校')
					return
				}

				// 切换状态
				item.compared = true
				// 触发父组件事件
				this.$emit('compare', item)
			},

			async handelFavorite(id, index, status) {
				if (!this.hasLogin) {
					this.$bus.$emit('showLoginModal')
					return
				}
				try {
					const res = await favorite({
						id: id,
						type: 1
					})
					if (res) {
						this.$message.success(status != 0 ? '取消收藏' : '已收藏')
						// res.errmsg)
						this.$emit('update', index, id)
					}
				} catch (err) {
					this.$message.error(err.errmsg)
				}
			},
			toDetail(type, id) {
				if (!this.detail) {
					this.$router.push(`/${type}/${id}`)
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	.ComButton {
		cursor: pointer;

		&:hover {
			opacity: .8;
		}
	}
</style>